/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const UPDATE_BILLING_ADDRESS_IN_CART = 'MFE/CHECKOUT/UPDATE_BILLING_ADDRESS_IN_CART';
export const UPDATE_BILLING_ADDRESS_IN_CART_SUCCESS = 'MFE/CHECKOUT/UPDATE_BILLING_ADDRESS_IN_CART_SUCCESS';
export const UPDATE_BILLING_ADDRESS_IN_CART_FAILED = 'MFE/CHECKOUT/UPDATE_BILLING_ADDRESS_IN_CART_FAILED';
export const UPDATE_BILLING_ADDRESS_IN_ADDRESS_BOOK = 'MFE/CHECKOUT/UPDATE_BILLING_ADDRESS_IN_ADDRESS_BOOK';

export const UPDATE_BILLING_ADDRESS_FORM = 'MFE/CHECKOUT/UPDATE_BILLING_ADDRESS_FORM';
export const UPDATE_BILLING_ADDRESS_FORM_BY_NAME = 'MFE/CHECKOUT/UPDATE_BILLING_ADDRESS_FORM_BY_NAME';
export const BILLING_ADDRESS_CLEAR_FORM = 'MFE/CHECKOUT/BILLING_ADDRESS_CLEAR_FORM';
export const BILLING_ADDRESS_IS_FORM_VALID = 'MFE/CHECKOUT/BILLING_ADDRESS_IS_FORM_VALID';
export const BILLING_ADDRESS_IS_FORM_AUTO_FILLED = 'MFE/CHECKOUT/BILLING_ADDRESS_IS_FORM_AUTO_FILLED';
export const BILLING_ADDRESS_SET_AS_DEFAULT = 'MFE/CHECKOUT/BILLING_ADDRESS_SET_AS_DEFAULT';
export const BILLING_ADDRESS_CHECK_SAME_AS_DELIVERY_ADDRESS = 'MFE/CHECKOUT/BILLING_ADDRESS_CHECK_SAME_AS_DELIVERY_ADDRESS';
